import {
  CLEAR_SELECTED_PAYBOX_IDS,
  CLEAR_SELECTED_PAYREGI_IDS,
  CLEAR_SELECTED_PAYSPOT_IDS,
  SET_LAST_DEVICE_PAGE_PATH,
} from 'admin/actions/devices';
import DeviceTypeSelect from 'admin/components/pages/SettingsDevice/DeviceTypeSelect';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ReactRouterPropTypes from 'react-router-prop-types';
import { bindActionCreators } from 'redux';
import Payboxes from './Payboxes';
import Payregis from './Payregis';
import Payspots from './Payspots';

class CreateDevice extends Component {
  componentDidMount() {
    const currentPath = this.props.location.pathname;
    const lastPath = this.props.lastDevicePagePath;

    if (lastPath && lastPath !== currentPath) {
      this.props.clearSelectedPayregiIds();
      this.props.clearSelectedPayspotIds();
      this.props.clearSelectedPayboxIds();
    }

    this.props.setLastDevicePagePath(currentPath);
  }

  getActiveTab = () => {
    const params = new URLSearchParams(this.props.location.search);
    const tab = params.get('tab');
    return ['payspot', 'payregi', 'oldpayregi', 'paybox', 'kiosk'].includes(tab) ? tab : 'payspot';
  };

  setActiveTab = (tab) => {
    this.props.clearSelectedPayregiIds();
    this.props.clearSelectedPayspotIds();
    this.props.clearSelectedPayboxIds();

    const params = new URLSearchParams();
    params.set('tab', tab);
    this.props.history.push({
      pathname: this.props.location.pathname,
      search: params.toString(),
    });
  };

  render() {
    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: '各種設定', href: '', active: true },
      { value: 'デバイス登録', href: '', active: true },
    ];

    const tab = this.getActiveTab();

    return (
      <div>
        <Breadcrumb items={crumb} />
        <DeviceTypeSelect
          activeDeviceTab={tab}
          onSelectPayspot={() => this.setActiveTab('payspot')}
          onSelectPayregi={() => this.setActiveTab('payregi')}
          onSelectOldPayregi={() => this.setActiveTab('oldpayregi')}
          onSelectPaybox={() => this.setActiveTab('paybox')}
          onSelectKiosk={() => this.setActiveTab('kiosk')}
        />
        {{
          payspot: () =>
            this.props.user.role === 'SERVICE-MANAGER' ? (
              <Payspots history={this.props.history} location={this.props.location} key="payspot" />
            ) : null,
          payregi: () =>
            this.props.user.role === 'SERVICE-MANAGER' ? (
              <Payregis
                key="payregi"
                location={this.props.location}
                history={this.props.history}
                defaultPcbVer={["v7"]}
              />
            ) : null,
          oldpayregi: () =>
            this.props.user.role === 'SERVICE-MANAGER' ? (
              <Payregis
                key="oldpayregi"
                location={this.props.location}
                history={this.props.history}
                defaultPcbVer={["v6_20200801", "PR1_v4"]}
              />
            ) : null,
          paybox: () =>
            this.props.user.role === 'SERVICE-MANAGER' ? (
              <Payboxes history={this.props.history} location={this.props.location} key="paybox" />
            ) : null,
          kiosk: () => null,
        }[tab]()}
      </div>
    );
  }
}

CreateDevice.propTypes = {
  location: ReactRouterPropTypes.location.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  user: PropTypes.object.isRequired,
  lastDevicePagePath: PropTypes.string,
  clearSelectedPayregiIds: PropTypes.func.isRequired,
  clearSelectedPayspotIds: PropTypes.func.isRequired,
  clearSelectedPayboxIds: PropTypes.func.isRequired,
  setLastDevicePagePath: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
  lastDevicePagePath: state.device.lastDevicePagePath,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      clearSelectedPayregiIds: () => dispatch(CLEAR_SELECTED_PAYREGI_IDS()),
      clearSelectedPayspotIds: () => dispatch(CLEAR_SELECTED_PAYSPOT_IDS()),
      clearSelectedPayboxIds: () => dispatch(CLEAR_SELECTED_PAYBOX_IDS()),
      setLastDevicePagePath: (path) => dispatch(SET_LAST_DEVICE_PAGE_PATH(path)),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CreateDevice));
